import React, {Component} from "react";
import {connect} from "react-redux";

import BloodScan from "./bloodscan"
import BloodScan40x from "./bloodscan40x"
import BmaScan40x from "./bmascan40x"
import {viewerType} from "../utils/const";
import {loadMorpheusSetting} from "../redux_actions/morpheus.setting.action";
import {mapSlideToProps} from "../redux_reducers/utils";
import {LoadingText} from "../component/gammaviewer/components/components";
import {initMapsState, loadFieldDisplaySetting, updateMapState} from "../redux_actions/maps.state.action";

class BloodViewerSelector extends Component {

	constructor(props) {
		super(props);

		this.props.dispatch(loadMorpheusSetting());
		this.props.dispatch(initMapsState([{slideId: this.props.match.params.id}]));
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.slide !== this.props.slide) {
			this.props.dispatch(updateMapState(this.props.activeMapId, {displaySetting: this.props.slide.display_setting}));
			this.props.dispatch(loadFieldDisplaySetting(this.props.activeMapId,
				this.props.slide.setting.field_display_setting));
		}
	}

	render() {
		if (!this.props.slide)
			return <LoadingText/>;
		switch (this.props.slide.viewer_type) {
			case viewerType.BLOOD:
				return <BloodScan {...this.props} />;
			case viewerType.BLOOD40X:
				return <BloodScan40x {...this.props} />;
			case viewerType.BMA40X:
				return <BmaScan40x {...this.props} />;
			default:
			    return null;
	    }
    }
}

export default connect(mapSlideToProps)(BloodViewerSelector);
